import { Checkbox, Form, Input } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

export const Title = styled.div`
  color: #0f5192;
  font-size: clamp(70px, 8vw, 70px);
  font-weight: 800;
  line-height: 125px;
  text-align: left;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    line-height: 60px;
    text-align: center;
    width: 360px;
  }
`;

export const StyledInput = styled(Input)`
  &&& {
    display: block;
    width: 400px;
    min-width: 250px;
    padding: 1rem;
    box-sizing: border-box;
    height: 50px;
    border: none;
    border-bottom: 2px solid #d9d9d9;
    font-size: 18px;

    &:focus {
      border-bottom: 2px solid #0f5192;
      box-shadow: none;
    }

    @media (max-width: 768px) {
      width: 100%;
      min-width: 380px;
      height: 50px;
      font-size: ${({ theme }) => theme.FONT_SIZE.md};
    }
  }
`;

export const StyledPasswordInput = styled(Input.Password)`
  &&& {
    display: flex;
    width: 400px;
    min-width: 250px;
    padding: 1rem;
    box-sizing: border-box;
    height: 50px;
    border: none;
    border-bottom: 2px solid #d9d9d9;
    font-size: 18px;

    &:focus {
      border-bottom: 2px solid #0f5192;
      box-shadow: none;
    }

    @media (max-width: 768px) {
      width: 100%;
      min-width: 380px;
      height: 50px;
      font-size: ${({ theme }) => theme.FONT_SIZE.md};
    }
  }
`;

export const LoginButton = styled.button`
  width: 400px;
  min-width: 250px;
  height: 50px;
  background-color: #0f5192;
  color: white;
  border: none;
  border-radius: 15px;
  font-size: 20px;
  cursor: pointer;

  &:hover {
    background-color: #485af9;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: 380px;
    height: 50px;
    font-size: ${({ theme }) => theme.FONT_SIZE.md};
    border-radius: 15px;
  }
`;

export const StyledForm = styled(Form)`
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const RememberStyledForm = styled(Form.Item)`
  width: 400px;
  display: flex;
  flex-direction: column;
`;

export const CompanySection = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: #0f5192;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: clamp(32px, 8vw, 78px);
  font-weight: 800;
  line-height: 125px;
  color: white;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const FormSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
    max-width: 464px;
  }
`;

export const LoginTip = styled.div`
  font-size: 17px;
  cursor: pointer;

  &:hover {
    color: #485af9;
  }
`;
